import { default as hour } from './hour/routes'
import { default as domainScheduleByDate } from './schedule-by-date/routes'
import { default as domainSchedule } from './schedule/routes'
import { default as domainHourGroup } from './group/routes'
import { default as domainTodayLookup } from './today-lookup/routes'

export default [
    ...hour,
    ...domainScheduleByDate,
    ...domainSchedule,
    ...domainHourGroup,
    ...domainTodayLookup
]
